export default __webpack_public_path__ + "static/media/img_17.e0c0dd38.jpg";